import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IdentifyCard from '../../identify-card';
import { getMapData } from '@selectors/map';
import {
  getTitles, HEADER_POST
} from '@utils/map-data-utils';
import styles from './identify-list.scss';

export function withIdentifyList(WrappedComponent) {
  if (!WrappedComponent) {
    WrappedComponent = Fragment;  // eslint-disable-line no-param-reassign
  }

  class IdentifyList extends Component {
    render() {
      const { mapSelection, onClickItem, mapRef, mapData, setParentEntity, parentId, ...passThroughProps } = this.props;
      if (!parentId) {
        return (
          <WrappedComponent {...passThroughProps}>
            {mapSelection && Object.entries(mapSelection).map(([, value], index) => {
              const detail = value.items[0];
              const {
                [HEADER_POST]: postHeader
              } = getTitles(mapData, detail);
              return (
                <div
                  className={classNames(styles.identifyCard, {
                    [styles.condensed]: !(postHeader || value.items.length),
                    [styles.tall]: (postHeader && value.items.length)
                  })}
                  key={`${detail.layerData.id}-${detail.data.id}`}
                >
                  <IdentifyCard
                    detailData={detail}
                    index={index}
                    onClick={onClickItem}
                    mapRef={mapRef}
                    itemList={value.items}
                    setParentEntity={setParentEntity}
                  />
                </div>
              );
            })}
          </WrappedComponent>
        );
      }
      return (
        <WrappedComponent {...passThroughProps}>
          {mapSelection[parentId].items.map((detail, index) => {
            const {
              [HEADER_POST]: postHeader
            } = getTitles(mapData, detail);
            return (
              <div
                className={classNames(styles.identifyCard, {[styles.condensed]: !postHeader})}
                key={`${detail.layerData.id}-${detail.data.id}`}
              >
                <IdentifyCard
                  detailData={detail}
                  index={index}
                  onClick={onClickItem}
                  mapRef={mapRef}
                  itemList={[]}
                  setParentEntity={setParentEntity}
                />
              </div>
            );
          })}
        </WrappedComponent>
      );
    }
  }

  IdentifyList.displayName = `withIdentifyList(${WrappedComponent.displayName || WrappedComponent.name}`;

  IdentifyList.propTypes = {
    mapData: PropTypes.object,
    mapRef: PropTypes.object.isRequired,
    mapSelection: PropTypes.object,
    onClickItem: PropTypes.func,
    parentId: PropTypes.number,
    setParentEntity: PropTypes.func
  };

  const mapStateToProps = state => ({
    mapData: getMapData(state)
  });

  return connect(mapStateToProps, {})(IdentifyList);
}

export default withIdentifyList();
